import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Table,
  Button,
  Label,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import FormRow from "../../components/Row/FormRow";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";
import SelectRow from "../../components/Select/SelectRow";
import { Utilites } from "../../core/Utilites";
import Constants from "../../core/Constants";
import MerchantSubItemModalAddUpdate from "../merchants-sub-items/MerchantSubItemModalAddUpdate";
import CustomerUserForm from "../customer-user/CustomerUserAddUpdateForm";
import CustomerVehicleForm from "../customer-vehicles/CustomerVehicleAddUpdateForm";
import { customerVehicleState } from "../customer-vehicles/CustomerVehiclesAddUpdate";
import MerchantWorkerForm from "../merchants-workers/MerchantWorkerAddUdateForm";
import { Scopes } from "../../shared/scopes.enum";
import { JobStatus, PrivateJobStatus } from "../../shared/job-statuses.enum";

export default class MerchantJobAddUpdate extends CoreEngine {
  defaultPassword = "P@ssword123";
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: this.defaultPassword,
        cityId: "",
      },
      testDriveNotes: "",
      customerId: "",
      customerUserList: [],
      customerWorkerList: [],
      customerVehicleList: [],
      serviceItems: [],
      code: "",
      description: "",
      serviceRows: [
        {
          selectedServiceItem: "",
          quantity: 1,
          description: "",
          subItems: [],
          received: null,
        },
      ],
      loading: false,
      status: "",

      statusOptions: [],
      selectedCustomerWorker: "",
      selectedCustomerVehicle: "",
      images: [],
      selectedItem: "",
      isModalOpen: false,
      cityList: [],
      modalType: "",
      name: "",
      title: "",
      workerIds: [],
      areAllItemsReceived: false,
      canWriteWorker: false,
      canWriteCustomer: false,
      canWriteCustomerVehicle: false,
      canWriteSubItems: false,
      showRejectBtn: false,
      setStatusToInProgress: false,
      showDriverFields: false,
      ...customerVehicleState,
    };

    this.engine = new RequestEngine();
    this.changeInput = this.changeInput.bind(this);
    this.addService = this.addService.bind(this);
    this.handleRowChange = this.handleRowChange.bind(this);
    this.fetchCustomerVehicles = this.fetchCustomerVehicles.bind(this); // Bind this method
  }

  async componentDidMount() {
    const selectedMerchant = sessionStorage.getItem("merchantId");
    const canWriteWorker = this.hasPermission([Scopes.MERCHANTS_WORKERS_WRITE]);
    const canWriteCustomer = this.hasPermission([Scopes.CUSTOMERS_USERS_WRITE]);
    const canWriteCustomerVehicle = this.hasPermission([
      Scopes.CUSTOMERS_VEHICLES_WRITE,
    ]);
    const canWriteSubItems = this.hasPermission([
      Scopes.MERCHANTS_SUBITEMS_WRITE,
    ]);
    this.setState({
      canWriteCustomer,
      canWriteCustomerVehicle,
      canWriteSubItems,
      canWriteWorker,
    });
    this.setState({ selectedMerchant }, async () => {
      this.pathname = `merchants/${selectedMerchant}/jobs`;
      const edit = this.props.location.data; // Retrieve edit data from props
      let itemsObject = this.props.location.itemsObject; // Retrieve itemsObject from props

      this.setState({
        serviceRows: [
          {
            selectedServiceItem: "",
            quantity: 1,
            description: "",
            selectedSubItem: [],
            received: null,
          }, // Initialize selectedSubItem as an empty array
        ],
      });

      if (edit) {
        const parsedItems = Array.isArray(itemsObject)
          ? itemsObject
          : typeof itemsObject === "string"
          ? JSON.parse(itemsObject)
          : [];
        let itemReceivedCount = 0;
        const serviceRows = parsedItems.map((item) => {
          const isReceived = item.received ?? null; // `received` field value
          if (isReceived) {
            itemReceivedCount++;
          }

          return {
            selectedServiceItem: item.merchantItem.id,
            quantity: item.quantity,
            description: item.merchantItem.description,
            selectedSubItems: item.merchantSubItem.map((subItem) => subItem.id),
            received: isReceived,
            canEdit: isReceived,
          };
        });
        this.setState(
          {
            ...edit,
            serviceRows,
            selectedCustomerWorker: edit.worker && edit.worker.id,
            images: edit.images,
            workerIds: edit.workers.map((worker) => worker.id),
            customerId: edit.customer && edit.customer.id,
            selectedCustomerVehicle:
              edit.customervehicle && edit.customervehicle.id,
            areAllItemsReceived:
              itemReceivedCount === serviceRows.length &&
              serviceRows.length !== 0,
            showRejectBtn: itemReceivedCount > 0,
            showDriverFields: edit.status === JobStatus.TEST_DRIVE,
          },
          async () => {
            if (this.state.customerId)
              this.fetchCustomerVehicles(this.state.customerId);

            await this.fetchSubItemsForRows(serviceRows);
            this.prepareData(); // Prepare data only for auxiliary fields
          }
        );
      } else {
        const { selectedMake, selectedModel } = this.state;
        this.fetchCodes();
        this.fetchEnergyOptions();
        this.fetchmakes();
        if (selectedMake) {
          this.setState({ selectedMake }, () => {
            this.fetchmodels();
          });
        }
        if (selectedModel) {
          this.setState({ selectedModel }, () => {
            this.fetchtrims();
          });
        }
        this.prepareData();
      }
    });
  }

  async prepareData() {
    const selectedMerchant = sessionStorage.getItem("merchantId");

    try {
      await this.fetchCustomerData(selectedMerchant);

      this.fetchWorkerData();

      const serviceResponse = await this.engine.getItemlistDirect(
        `merchants/${selectedMerchant}/items`
      );
      if (serviceResponse) {
        const services = serviceResponse.data.items;
        const serviceItems = services.map((s) => ({
          value: s.id,
          label: `${s.code} - ${s.description} `,
        }));
        this.setState({ serviceItems });

        if (!this.props.location.data && this.state.serviceRows.length === 0) {
          this.setState({
            serviceRows: [
              {
                selectedServiceItem: "",
                quantity: 1,
                description: "",
                subItems: [],
                received: null,
              },
            ],
          });
        }
      }
    } catch (error) {
      console.error("Error preparing data:", error);
    }
  }

  async fetchWorkerData() {
    const responseWorker = await this.engine.getItemlistDirect(
      `merchants/${this.state.selectedMerchant}/workers`
    );
    if (responseWorker) {
      const workers = responseWorker.data.items;
      const customerWorkerList = workers.map((w) => ({
        value: w.id,
        label: `${w.name}-${w.title}`,
      }));
      this.setState({ customerWorkerList });
    }
  }

  async fetchCustomerData(selectedMerchant) {
    try {
      const responseCustomer = await this.engine.getItemlistDirect(
        `customers/${selectedMerchant}/users`
      );
      if (responseCustomer) {
        const customerData = responseCustomer.data.items;
        const customerUserList = customerData.map((c) => ({
          value: c.id,
          label: `${c.user.firstName} ${c.user.lastName} - ${c.merchant.name}`,
        }));
        this.setState({ customerUserList });
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  }

  async fetchCustomerVehicles(customerId) {
    try {
      const responseVehicle = await this.engine.getItemlistDirect(
        `customers/${customerId}/Vehicle`
      );
      if (responseVehicle) {
        const customerVehicleList = responseVehicle.data.items.map(
          (vehicle) => ({
            value: vehicle.id,
            label: `${vehicle.make.name} ${vehicle.model.name} - ${vehicle.plateCode} ${vehicle.plateNumber}  `,
          })
        );
        this.setState({ customerVehicleList });
      }
    } catch (error) {
      console.error("Error fetching customer vehicles:", error);
    }
  }

  handleCustomerUserSelect(selectedOption) {
    const customerId = selectedOption.value;
    this.setState(
      {
        customerId,
        customerVehicleList: [],
      },
      () => {
        this.fetchCustomerVehicles(customerId);
      }
    );
  }

  changeInput = (e, field) => {
    const value = e.target?.value ?? e.value;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    this.setState({ [field]: trimmedValue });
  };

  addService() {
    this.setState((prevState) => ({
      serviceRows: [
        ...prevState.serviceRows,
        {
          selectedServiceItem: "",
          quantity: 1,
          description: "",
          subItems: [],
          received: null,
        },
      ],
    }));
  }

  async fetchSubItems(selectedMerchant, itemId) {
    try {
      const response = await this.engine.getItemlistDirect(
        `merchants/${selectedMerchant}/sub-items/${itemId}`
      );
      if (response) {
        return response.data.items.map((subItem) => ({
          value: subItem.id,
          label: `${subItem.code}- ${subItem.description}`,
        }));
      }
    } catch (error) {
      console.error("Error fetching sub-items:", error);
      return [];
    }
  }

  async fetchSubItemsForRows(serviceRows) {
    const updatedRows = [...serviceRows];
    for (let i = 0; i < updatedRows.length; i++) {
      const row = updatedRows[i];
      if (row.selectedServiceItem) {
        const subItems = await this.fetchSubItems(
          this.state.selectedMerchant,
          row.selectedServiceItem
        );
        updatedRows[i].subItems = subItems;

        // Ensure selectedSubItems are populated with both value and label
        if (row.selectedSubItems.length > 0) {
          updatedRows[i].selectedSubItems = row.selectedSubItems.map(
            (subItemId) => {
              return subItems.find((subItem) => subItem.value === subItemId);
            }
          );
        }
      }
    }
    this.setState({ serviceRows: updatedRows });
  }

  async handleRowChange(index, field, value) {
    const updatedRows = [...this.state.serviceRows];

    if (field === "selectedServiceItem") {
      const subItems = await this.fetchSubItems(
        this.state.selectedMerchant,
        value
      );
      updatedRows[index].subItems = subItems;

      // Update selectedSubItems with both value and label
      updatedRows[index].selectedSubItems = [];
    }

    if (field === "selectedSubItem") {
      // Ensure selectedSubItems contain both value and label (not just IDs)
      updatedRows[index].selectedSubItems = value
        ? value.map((item) => ({
            value: item,
            label: updatedRows[index].subItems.find(
              (subItem) => subItem.value === item
            )?.label,
          }))
        : [];
    }
    if (field === "received") {
      this.setState({ setStatusToInProgress: true });
    }

    updatedRows[index][field] = value;

    this.setState({ serviceRows: updatedRows }, () => {});
  }
  base64Images = (images) =>
    images.filter((image) => image.includes("data:image"));

  handleValidSubmit = async (passedStatus) => {
    if (
      [PrivateJobStatus.REJECTED, PrivateJobStatus.COMPLETED].includes(
        passedStatus
      )
    ) {
      const { departureMileage, testDriveNotes } = this.state;

      if (!departureMileage) {
        alert("Please Enter Departure Mileage");
        return;
      }

      if (passedStatus === PrivateJobStatus.REJECTED && !testDriveNotes) {
        alert("Please Make sure to add Test Drive Notes");
        return;
      }
    }

    this.setState({ loading: true });

    const {
      customerId,
      serviceRows,
      selectedCustomerWorker,
      selectedCustomerVehicle,
      id,
      images,
      arrivalMileage,
      departureMileage,
      representative,
      representativePhone,
      note,
      workerIds,
      testDriveNotes,
      ...data
    } = this.state;

    const base64Images = this.base64Images(images);
    const items = serviceRows.map((row) => ({
      itemId: row.selectedServiceItem,
      quantity: row.quantity,
      subItemIds: row.selectedSubItems?.map((obj) => obj.value) || [],
      received: row.received,
    }));

    const postData = {
      customerId,
      workerIds: workerIds,
      customervehicleId: selectedCustomerVehicle,
      arrivalMileage,
      departureMileage,
      representative,
      representativePhone,
      note,
      images,
      items,
    };

    try {
      let response;

      if (id) {
        let otherData = {
          images: base64Images,
          arrivalMileage,
          departureMileage: parseInt(departureMileage),
          representative,
          representativePhone,
          note,
          workerIds,
          items,
          testDriveNotes,
        };

        if (this.state.areAllItemsReceived)
          otherData.status = JobStatus.IN_PROGRESS;
        if (passedStatus) otherData.status = passedStatus;

        response = await this.engine.updateItem(this.pathname, this.state.id, {
          ...data,

          ...otherData,
        });
      } else {
        response = await this.engine.saveItem(this.pathname, postData);
      }

      if (response && (response.status === 201 || response.status === 200)) {
        this.props.history.push(
          `/admin/merchant/${this.state.selectedMerchant}/jobs`
        );
      }
    } catch (err) {
      if (err.response && err.response.data.message) {
        alert(
          "Error: " +
            (Array.isArray(err.response.data?.message)
              ? err.response.data?.message.join(", ")
              : err.response.data?.message)
        );
      } else {
        alert("An unexpected error occurred: " + err.message);
      }
    }

    this.setState({ loading: false });
  };

  removeService(index) {
    this.setState((prevState) => {
      const updatedRows = [...prevState.serviceRows];
      updatedRows.splice(index, 1); // Remove the row at the specified index
      return { serviceRows: updatedRows };
    });
  }

  onChangePic(e) {
    if (!e.target.files || e.target.files.length === 0) {
      return; // No files selected, return early
    }

    const newImages = [...this.state.images]; // Clone the existing images array

    // Loop through all selected files
    Array.from(e.target.files).forEach((file) => {
      Utilites.getFileBase64(file, (result) => {
        newImages.push(result); // Add the base64 result to the images array
        this.setState({ images: newImages, isImageChanged: true });
      });
    });
  }

  async fetchImagesFromBackend(imagePaths) {
    const images = [];

    for (let i = 0; i < imagePaths.length; i++) {
      const imagePath = imagePaths[i];

      try {
        const response = await this.engine.getItemlistDirect(
          `merchants/${this.state.selectedMerchant}/jobs/${imagePath}`
        );

        if (response && response.data) {
          images.push(response.data);
        }
      } catch (error) {
        console.error("Error fetching image from backend:", error);
      }
    }

    return images;
  }

  handleDeleteSubItem = (rowIndex, subIndex) => {
    const selectedSubItems = [...this.state.data[rowIndex].selectedSubItem];

    selectedSubItems.splice(subIndex, 1);

    this.setState((prevState) => {
      const updatedData = [...prevState.data];
      updatedData[rowIndex].selectedSubItem = selectedSubItems;

      return { data: updatedData };
    });
  };

  removeImage = (index) => {
    const image = this.state.images[index];

    const confirmDelete = window.confirm(strings.confirmdelete);

    if (!confirmDelete) {
      return;
    }

    if (image.includes("data:image")) {
      const updatedImages = this.state.images.filter((_, i) => i !== index);
      this.setState({ images: updatedImages });
    } else {
      const { selectedMerchant, id } = this.state;
      const fileName = image;

      this.removeImageFromServer(id, fileName, selectedMerchant);
    }
  };

  handleSubItemInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  removeImageFromServer = async (jobId, fileName, selectedMerchant) => {
    const deleteUrl = `${
      Constants.serverlink
    }api/v1/merchants/{merchantId}/jobs/${jobId}/delete-image/${encodeURIComponent(
      fileName
    )}`;
    fetch(deleteUrl, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.ok) {
        const updatedImages = this.state.images.filter(
          (image) => image !== fileName
        );

        this.setState({ images: updatedImages });
      } else {
        alert("Error deleting image");
      }
    });
  };

  handleItemSelect = (index, itemId) => {
    this.setState(
      { selectedItemId: itemId, selectedRowIndex: index },
      this.toggleModal
    );
  };
  toggleModal = (modalType = "", data = {}) => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
      modalType,
      ...data,
    }));
  };

  fetchCities = async () => {
    try {
      const response = await this.engine.getItemlistDirect("cities");
      if (response) {
        const cityList = response.data.items.map((city) => ({
          value: city.id,
          label: city.name,
        }));
        this.setState({ cityList });
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  customerChangeInput = (e) => {
    const { name, value } = e.target || {};
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        [name]: trimmedValue,
      },
    }));
  };

  handleSubItemSubmit = async () => {
    this.setState({ loading: true });

    const updatedRows = [...this.state.serviceRows];
    const { code, description, selectedItemId, selectedRowIndex } = this.state;

    const data = { code, description };

    let response;
    try {
      if (selectedItemId) {
        response = await this.engine.saveItem(
          `merchants/{merchantId}/sub-items/${selectedItemId}`,
          data
        );

        const subItems = await this.fetchSubItems(
          this.state.selectedMerchant,
          selectedItemId
        );
        updatedRows[selectedRowIndex].subItems = subItems;
        updatedRows[selectedRowIndex].selectedSubItem = [
          ...(updatedRows[selectedRowIndex].selectedSubItems || []),
          response.data.id,
        ];
        updatedRows[selectedRowIndex].selectedSubItems = [
          ...(updatedRows[selectedRowIndex].selectedSubItems || []),
          {
            value: response.data.id,
            label: `${response.data.code}- ${response.data.description}`,
          },
        ];

        this.setState({ serviceRows: updatedRows }, () =>
          this.getFilteredSubItems(selectedRowIndex)
        );
      } else {
        alert(strings.error);
      }

      this.toggleModal();
    } catch (err) {
      console.error("Error while saving:", err);
    }

    this.setState({ loading: false });
  };

  handleCustomerUserSubmit = async () => {
    this.setState({ loading: true });
    const { user } = this.state;
    const payload = {
      user: {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phoneNumber: user.phoneNumber,
        password: this.defaultPassword,
      },
      cityId: user.cityId,
    };

    const { selectedMerchant } = this.state;

    try {
      let response;

      response = await this.engine.saveItem(
        `customers/${selectedMerchant}/users`,
        payload
      );

      if ((response && response.status === 201) || response.status === 200) {
        this.fetchCustomerData(selectedMerchant);

        this.setState({
          customerId: response.data.id,
          modalOpen: false,
        });
      } else {
        alert(strings.error);
        this.setState({ modalOpen: false });
      }
    } catch (error) {
      alert(strings.error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleWorkerSubmit = async () => {
    this.setState({ loading: true });

    const { selectedMerchant, name, title } = this.state;
    let response;

    const data = {
      name,
      title,
    };

    try {
      response = await this.engine.saveItem(
        `merchants/${selectedMerchant}/workers`,
        data
      );

      if (response && (response.status === 201 || response.status === 200)) {
        await this.fetchWorkerData();

        this.setState((prevState) => ({
          workerIds: [...prevState.workerIds, response.data.id],
          modalOpen: false,
        }));
      }
    } catch (err) {
      const errorMessageArray = err.response?.data?.message;

      alert("An unexpected error occurred: " + errorMessageArray);
    }

    this.setState({ loading: false });
  };

  handleSubItemInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleCustomerVehicleSubmit = async () => {
    this.setState({ loading: true });

    const {
      isTrimSelected,
      selectedMake,
      selectedModel,
      trimId,
      year,
      plateNumber,
      plateCode,
      energy,
      isGCC,
      vin,
      username,
      customerId,
    } = this.state;

    let response;

    try {
      let postData = {
        makeId: selectedMake,
        modelId: selectedModel,
        trimId: isTrimSelected ? trimId : undefined,
        year,
        isGCC,
        vin,
        username,
        plateNumber,
        plateCode: plateCode,
        energy,
      };

      response = await this.engine.saveItem(
        `customers/${customerId}/Vehicle`,
        postData
      );

      if (response && (response.status === 201 || response.status === 200)) {
        this.fetchCustomerVehicles(customerId);
        this.setState({
          selectedCustomerVehicle: response.data.id,
          modalOpen: false,
        });
      }
    } catch (err) {
      console.error("Submission error:", err);

      if (err.response && err.response.data && err.response.data.message) {
        const errorMessage = err.response.data.message.join(", ");
        alert(`Error: ${errorMessage}`);
      } else {
        alert(strings.error);
      }
    }

    this.setState({ loading: false });
  };

  getFilteredSubItems = (rowIndex) => {
    const { serviceRows } = this.state;

    const currentRow = serviceRows[rowIndex];

    const selectedSubItems = serviceRows.reduce((acc, row, index) => {
      if (
        index !== rowIndex &&
        row.selectedServiceItem === currentRow.selectedServiceItem
      ) {
        return acc.concat(row.selectedSubItems || []);
      }
      return acc;
    }, []);

    const filteredSubItems = (currentRow.subItems || []).filter(
      (subItem) =>
        !selectedSubItems.some((selected) => selected.value === subItem.value)
    );

    return filteredSubItems;
  };

  handleInputChange = (input, name) => {
    if (name) {
      const newValue = input ? input.value : "";
      const trimmedValue =
        typeof newValue === "string" ? newValue.trim() : newValue;

      this.setState({
        [name]: trimmedValue,
      });
    } else if (input && input.target) {
      const { name, value } = input.target;
      const trimmedValue = typeof value === "string" ? value.trim() : value;
      this.setState({
        [name]: trimmedValue,
      });
    }
  };

  renderServiceTable() {
    const { serviceRows, serviceItems, canWriteSubItems, status } = this.state;

    const cannotEditItems =
      status !== JobStatus.INSPECTION && status !== JobStatus.REGISTRATION;

    return (
      <Table bordered>
        <thead>
          <tr>
            <th style={{ width: "200px", textAlign: "center" }}>
              {strings.service + " " + strings.itemcode}
            </th>
            <th style={{ width: "200px", textAlign: "center" }}>
              {strings.subitems}
            </th>
            <th style={{ width: "150px" }}>{strings.quantity}</th>
            {cannotEditItems && (
              <th style={{ width: "100px", textAlign: "center" }}>Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {serviceRows.map((row, index) => (
            <tr key={index}>
              <td>
                <SelectRow
                  showDeleteButton={!row.received && !cannotEditItems}
                  onDeleteClick={() => this.removeService(index)}
                  name={`serviceItem_${index}`}
                  value={row.selectedServiceItem || ""}
                  defaultValue={row.selectedServiceItem}
                  readonly={row.received || cannotEditItems}
                  data={serviceItems}
                  changeInput={(e) =>
                    this.handleRowChange(index, "selectedServiceItem", e.value)
                  }
                />
              </td>

              <td style={{ textAlign: "center" }}>
                <div>
                  <SelectRow
                    isMulti={true}
                    name={`subItem_${index}`}
                    value={row.selectedSubItems || []}
                    data={this.getFilteredSubItems(index) || []}
                    readonly={row.received || cannotEditItems}
                    changeInput={(e) =>
                      this.handleRowChange(
                        index,
                        "selectedSubItem",
                        e ? e.map((item) => item.value) : []
                      )
                    }
                    defaultValue={row.selectedSubItems || []}
                    showAddButton={
                      row.selectedServiceItem &&
                      !row.received &&
                      canWriteSubItems &&
                      !cannotEditItems
                    }
                    onAddClick={() =>
                      this.toggleModal("SubItemForm", {
                        selectedItemId: row.selectedServiceItem,
                        selectedRowIndex: index,
                      })
                    }
                  />
                </div>
              </td>

              <td style={{ textAlign: "center" }}>
                <FormRow
                  type="number"
                  name={`quantity_${index}`}
                  data={row.quantity || 1}
                  required={false}
                  readonly={row.received || cannotEditItems}
                  changeInput={(e) =>
                    this.handleRowChange(index, "quantity", e.target.value)
                  }
                />
              </td>

              {cannotEditItems && (
                <td style={{ textAlign: "center" }}>
                  <label>{strings.received}:</label>
                  <div>
                    <input
                      type="radio"
                      id={`receivedYes_${index}`}
                      name={`received_${index}`}
                      checked={row.received === true}
                      value={true}
                      disabled={row.canEdit}
                      onChange={() =>
                        this.handleRowChange(index, "received", true)
                      }
                    />
                    <label
                      htmlFor={`receivedYes_${index}`}
                      style={{ marginRight: "10px" }}
                    >
                      {strings.yes}
                    </label>

                    <input
                      type="radio"
                      id={`receivedNo_${index}`}
                      name={`received_${index}`}
                      checked={row.received === false}
                      value={false}
                      disabled={row.canEdit}
                      onChange={() =>
                        this.handleRowChange(index, "received", false)
                      }
                    />
                    <label htmlFor={`receivedNo_${index}`}>{strings.no}</label>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  render() {
    const {
      isLoading,
      id,
      customerId,
      customerUserList,
      customerWorkerList,
      customerVehicleList,
      status,
      arrivalMileage,
      departureMileage,
      representative,
      representativePhone,
      note,
      testDriveNotes,
      modalOpen,
      code,
      description,
      loading,
      modalType,
      user,
      cityList,
      name,
      title,
      selectedCustomerVehicle,
      areAllItemsReceived,
      canWriteCustomer,
      canWriteCustomerVehicle,
      canWriteWorker,
      showDriverFields,
      serviceRows,
    } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    const isAllChecked = serviceRows.every((row) => row.received !== null);
    const isAllSelected =
      serviceRows.length > 0 &&
      serviceRows.every((row) => {
        if (row.selectedSubItems && Array.isArray(row.selectedSubItems)) {
          return row.selectedSubItems.length > 0;
        }
      });

    const showSendItemsRequest =
      status === JobStatus.REGISTRATION || status === JobStatus.INSPECTION;

    const showSendForTestDrive =
      status === JobStatus.IN_PROGRESS && isAllChecked;

    const showDeleteImage =
      status !== JobStatus.IN_PROGRESS && status !== JobStatus.TEST_DRIVE;

    const onHold = status === JobStatus.ON_HOLD;

    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={() => this.handleValidSubmit()}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <Row className="mx-3 my-3">
                    <Col>
                      <CardTitle tag="h4">{strings.information}</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <>
                    <SelectRow
                      readonly={onHold}
                      isMulti={true}
                      label={strings.worker}
                      name="workerId"
                      value={this.state.workerIds.map((id) =>
                        customerWorkerList.find((worker) => worker.value === id)
                      )}
                      data={customerWorkerList}
                      defaultValue={this.state.workerIds.map((id) =>
                        customerWorkerList.find((worker) => worker.value === id)
                      )}
                      changeInput={(e) => {
                        const selectedWorkerIds = e
                          ? e.map((worker) => worker.value)
                          : [];
                        this.setState({ workerIds: selectedWorkerIds });
                      }}
                      showAddButton={canWriteWorker && !onHold}
                      onAddClick={() => this.toggleModal("WorkerForm")}
                    />
                    {!id && (
                      <SelectRow
                        label={strings.customer}
                        name="customerId"
                        defaultValue={customerId}
                        data={customerUserList}
                        changeInput={(e) => this.handleCustomerUserSelect(e)}
                        showAddButton={canWriteCustomer}
                        onAddClick={async () => {
                          await this.fetchCities();
                          this.toggleModal("CustomerUserForm");
                        }}
                      />
                    )}
                    {id && (
                      <FormRow
                        label={strings.customer}
                        readonly={true}
                        required={false}
                        name="customerId"
                        data={
                          customerUserList.find((c) => c.value === customerId)
                            ?.label
                        }
                        changeInput={this.changeInput}
                      />
                    )}
                    {!id && (
                      <SelectRow
                        label={strings.vehicle}
                        name="customervehicle"
                        viewonly={id}
                        defaultValue={selectedCustomerVehicle}
                        data={customerVehicleList}
                        changeInput={(e) =>
                          this.setState({ selectedCustomerVehicle: e.value })
                        }
                        showAddButton={customerId && canWriteCustomerVehicle}
                        onAddClick={() => {
                          this.toggleModal("VehicleForm");
                        }}
                      />
                    )}

                    {id && (
                      <FormRow
                        label={strings.vehicle}
                        readonly={true}
                        required={false}
                        name="customervehicle"
                        data={
                          customerVehicleList.find(
                            (c) => c.value === selectedCustomerVehicle
                          )?.label
                        }
                        changeInput={this.changeInput}
                      />
                    )}
                  </>
                  <FormRow
                    type="number"
                    label={strings.arrivalmileage}
                    readonly={id}
                    required={!id}
                    name="arrivalMileage"
                    data={arrivalMileage}
                    changeInput={this.changeInput}
                  />
                  {showDriverFields && (
                    <FormRow
                      type="number"
                      required={true}
                      label={strings.departureMileage}
                      name="departureMileage"
                      data={departureMileage}
                      changeInput={this.changeInput}
                    />
                  )}
                  {!id && (
                    <>
                      <FormRow
                        label={strings.driver}
                        required={false}
                        name="representative"
                        data={representative}
                        changeInput={this.changeInput}
                      />
                      <FormRow
                        label={strings.driverphonenumber}
                        required={false}
                        type="number"
                        name="representativePhone"
                        data={representativePhone}
                        changeInput={this.changeInput}
                      />
                    </>
                  )}
                  <FormRow
                    label={strings.note}
                    readonly={id}
                    required={false}
                    type="textarea"
                    name="note"
                    data={note}
                    changeInput={this.changeInput}
                  />
                  {showDriverFields && (
                    <>
                      <FormRow
                        label={strings.testdrivenote}
                        required={false}
                        type="textarea"
                        name="testDriveNotes"
                        data={testDriveNotes}
                        changeInput={this.changeInput}
                      />
                    </>
                  )}

                  {(showDriverFields || !id) && (
                    <Row>
                      <Label sm="2">{strings.images}</Label>
                      <Col sm="10">
                        <FormGroup>
                          <Button
                            color="primary"
                            onClick={() =>
                              document.getElementById("imageUpload").click()
                            }
                            style={{
                              marginBottom: "15px",
                            }}
                          >
                            {strings.select + " " + strings.images}
                          </Button>
                          <input
                            type="file"
                            id="imageUpload"
                            name="imageUpload"
                            multiple
                            style={{ display: "none" }}
                            onChange={(e) => this.onChangePic(e)}
                          />
                        </FormGroup>

                        <div
                          style={{
                            display: "flex",
                            overflowX: "auto", // Enables horizontal scrolling
                            gap: "10px", // Adds spacing between images
                            paddingBottom: "10px", // Optional: Adds space for scrollbar
                          }}
                        >
                          {this.state.images.map((image, index) => (
                            <div
                              key={index}
                              style={{
                                flex: "0 0 auto", // Ensures the container doesn't shrink or grow
                                width: "200px",
                                height: "200px",
                                position: "relative",
                                overflow: "hidden",
                                borderRadius: "5px",
                              }}
                            >
                              <img
                                src={
                                  image.includes("data:image")
                                    ? image
                                    : `${Constants.serverlink}api/v1/merchants/${this.state.selectedMerchant}/jobs/${image}`
                                }
                                alt={`Uploaded ${index}`}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  cursor: "pointer",
                                }}
                              />
                              {(showDeleteImage ||
                                image.includes("data:image")) && (
                                <button
                                  onClick={() => this.removeImage(index)}
                                  style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    backgroundColor: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <i
                                    className="fa fa-times"
                                    style={{ color: "red" }}
                                  />
                                </button>
                              )}
                            </div>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  )}

                  {id && this.renderServiceTable()}
                  {id && showSendItemsRequest && (
                    <>
                      <Button color="success" onClick={this.addService}>
                        + Add Service
                      </Button>
                    </>
                  )}
                </CardBody>
                <CardFooter className="text-center">
                  {!showSendForTestDrive && !onHold && !showDriverFields && (
                    <ButtonLoader
                      color="primary"
                      loading={this.state.loading}
                      onClick={() => {
                        if (this.state.setStatusToInProgress) {
                          this.handleValidSubmit(JobStatus.IN_PROGRESS);
                        } else {
                          this.handleValidSubmit();
                        }
                      }}
                    >
                      {strings.save}
                    </ButtonLoader>
                  )}
                  {showDriverFields && (
                    <ButtonLoader
                      color="danger"
                      loading={this.state.loading}
                      style={{ float: "left" }}
                      onClick={() => {
                        this.handleValidSubmit(PrivateJobStatus.REJECTED);
                      }}
                    >
                      {strings.reject}
                    </ButtonLoader>
                  )}
                  {showDriverFields && (
                    <ButtonLoader
                      color="primary"
                      style={{ float: "right" }}
                      loading={this.state.loading}
                      onClick={() => {
                        this.handleValidSubmit(PrivateJobStatus.COMPLETED);
                      }}
                    >
                      {strings.complete}
                    </ButtonLoader>
                  )}
                  {onHold && (
                    <>
                      <ButtonLoader
                        color="primary"
                        loading={this.state.loading}
                        onClick={() =>
                          this.handleValidSubmit(JobStatus.INSPECTION)
                        }
                      >
                        {strings.sendtogarage}
                      </ButtonLoader>
                    </>
                  )}
                  {showSendForTestDrive && (
                    <>
                      <ButtonLoader
                        color="primary"
                        loading={this.state.loading}
                        onClick={() =>
                          this.handleValidSubmit(JobStatus.TEST_DRIVE)
                        }
                      >
                        {strings.sendfortestdrive}
                      </ButtonLoader>
                    </>
                  )}
                  {showSendItemsRequest && isAllSelected && (
                    <>
                      <div style={{ width: "50px", height: "50px" }}></div>
                      <ButtonLoader
                        color="primary"
                        loading={this.state.loading}
                        onClick={() =>
                          this.handleValidSubmit(
                            PrivateJobStatus.WAITING_FOR_APPROVAL
                          )
                        }
                      >
                        {strings.saveandsendforapproval}
                      </ButtonLoader>
                    </>
                  )}
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
        <div>
          <Modal isOpen={modalOpen} toggle={this.toggleModal}>
            <ModalHeader toggle={this.toggleModal}>
              {modalType === "SubItemForm" &&
                `${strings.add} ${strings.subitem}`}
              {modalType === "CustomerUserForm" &&
                `${strings.add} ${strings.customeruser}`}
              {modalType === "VehicleForm" &&
                `${strings.add} ${strings.customervehicle}`}
              {modalType === "WorkerForm" && `${strings.add} ${strings.worker}`}
            </ModalHeader>
            <ModalBody>
              {modalType === "SubItemForm" && (
                <MerchantSubItemModalAddUpdate
                  code={code}
                  description={description}
                  handleSubmit={this.handleSubItemSubmit}
                  changeInput={this.handleSubItemInputChange}
                  loading={loading}
                  CardStyle={{ boxShadow: "none", border: "none" }}
                />
              )}
              {modalType === "VehicleForm" && (
                <CustomerVehicleForm
                  {...this.state}
                  makes={this.state.makes}
                  handleValidSubmit={this.handleCustomerVehicleSubmit}
                  handleMakeSelect={this.handleMakeSelect}
                  handleModelSelect={this.handleModelSelect}
                  handleTrimSelect={this.handleTrimSelect}
                  handleInputChange={this.handleInputChange}
                  handleTextChange={this.changeInput}
                  CardStyle={{ boxShadow: "none", border: "none" }}
                />
              )}
              {modalType === "CustomerUserForm" && (
                <CustomerUserForm
                  user={user}
                  citylist={cityList}
                  changeInput={this.customerChangeInput}
                  handleValidSubmit={this.handleCustomerUserSubmit}
                  loading={loading}
                  CardStyle={{ boxShadow: "none", border: "none" }}
                />
              )}
              {modalType === "WorkerForm" && (
                <MerchantWorkerForm
                  name={name}
                  title={title}
                  loading={loading}
                  handleValidSubmit={this.handleWorkerSubmit}
                  handleInputChange={this.changeInput}
                  CardStyle={{ boxShadow: "none", border: "none" }}
                />
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggleModal}>
                Close
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    );
  }
}
